(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bottle-shape-selector"] && !Shopify.designMode) return;
  try {
    (() => {
    const roots = document.querySelectorAll('[data-bss-root]');
    if (!roots.length) return;

    roots.forEach((root) => {
      const dataNode = root.querySelector('[data-bss-data]');
      const variantsNode = root.querySelector('[data-bss-variants]');
      const grid = root.querySelector('[data-bss-grid]');
      const hint = root.querySelector('[data-bss-hint]');
      const error = root.querySelector('[data-bss-error]');
      const sizeText = root.querySelector('[data-bss-size]');
      const formId = root.getAttribute('data-product-form-id');
      const shapeInput = root.querySelector('input[name="properties[Shape]"]');
      const picker = document.querySelector(`hdt-variant-picker[form="${formId}"]`);
      const form = document.getElementById(formId);

      if (!dataNode || !variantsNode || !grid || !shapeInput) return;

      let map;
      let variants;

      try {
        map = JSON.parse(dataNode.textContent || '{}');
        variants = JSON.parse(variantsNode.textContent || '[]');
      } catch (parseError) {
        root.hidden = true;
        return;
      }

      if (!map || typeof map !== 'object' || Array.isArray(map)) {
        root.hidden = true;
        return;
      }

      const variantById = new Map(variants.map((item) => [String(item.id), item]));
      let selectedShape = '';

      const normalize = (value) => (value || '').toString().trim();

      const getSelectedVariantId = () => {
        if (picker && picker.getAttribute('selected-variant')) {
          return picker.getAttribute('selected-variant');
        }

        if (form) {
          const variantInput = form.querySelector('input[name="id"]:not([disabled]), select[name="id"]');
          if (variantInput && variantInput.value) return variantInput.value;
        }

        return '';
      };

      const getCurrentSize = () => {
        if (picker) {
          const labelValue = picker.querySelector('fieldset[data-index="0"] [update-value]');
          if (labelValue && labelValue.textContent.trim()) {
            return normalize(labelValue.textContent);
          }
        }

        const variantId = getSelectedVariantId();
        if (variantId && variantById.has(String(variantId))) {
          return normalize(variantById.get(String(variantId)).option1);
        }

        return '';
      };

      const setSelectedShape = (shapeName, cardNode) => {
        selectedShape = shapeName;
        shapeInput.value = shapeName;
        grid.querySelectorAll('.bss-card').forEach((card) => card.classList.remove('is-active'));
        if (cardNode) cardNode.classList.add('is-active');
        if (error) error.hidden = true;
      };

      const renderShapes = () => {
        const size = getCurrentSize();
        sizeText.textContent = size || '—';
        grid.innerHTML = '';
        shapeInput.value = '';
        selectedShape = '';

        const shapes = Array.isArray(map[size]) ? map[size] : [];
        if (!shapes.length) {
          if (hint) {
            hint.hidden = false;
            hint.textContent = size
              ? 'No bottle shapes configured for this size.'
              : 'Select a size to see bottle shapes.';
          }
          return;
        }

        if (hint) hint.hidden = true;

        shapes.forEach((shape, index) => {
          if (!shape || !shape.name) return;

          const card = document.createElement('button');
          card.type = 'button';
          card.className = 'bss-card';
          card.setAttribute('aria-pressed', 'false');
          card.innerHTML = `
            <span class="bss-image-wrap">
              <img class="bss-image" src="${shape.image || ''}" alt="${shape.name}">
            </span>
          `;

          card.addEventListener('click', () => {
            setSelectedShape(shape.name, card);
            grid.querySelectorAll('.bss-card').forEach((node) => node.setAttribute('aria-pressed', 'false'));
            card.setAttribute('aria-pressed', 'true');
          });

          grid.appendChild(card);

          if (index === 0) {
            setSelectedShape(shape.name, card);
            card.setAttribute('aria-pressed', 'true');
          }
        });
      };

      const syncOnInteraction = () => window.requestAnimationFrame(renderShapes);

      if (picker) {
        picker.addEventListener('change', syncOnInteraction);
        picker.addEventListener('click', (event) => {
          if (event.target.closest('[data-option-position="1"], [name="option1"], [for*="-option1-"]')) {
            syncOnInteraction();
          }
        });

        const observer = new MutationObserver((mutations) => {
          const shouldSync = mutations.some(
            (mutation) => mutation.type === 'attributes' && mutation.attributeName === 'selected-variant'
          );
          if (shouldSync) syncOnInteraction();
        });
        observer.observe(picker, { attributes: true });
      }

      if (form) {
        form.addEventListener('submit', (event) => {
          if (!selectedShape) {
            event.preventDefault();
            if (error) error.hidden = false;
          }
        });
      }

      renderShapes();
      root.hidden = false;
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
